<template>
	<div class="xs-12">
		<core-form-input
			componentName="j-base-input-number"
			name="premium"
			type="float"
			v-validate="'required'"
			v-model="premium"
			:validationErrors="errors"
			aria-autocomplete="none"
			@enter="handleSave"
		/>

		<div class="flex xs-between mt6">
			<j-button :isLoading="isLoading" @click="handleSave" type="primary">
				{{ $t("save") }}
			</j-button>
			<j-button @click="handleCancel" type="bordered">
				{{ $t("cancel") }}
			</j-button>
		</div>
	</div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton"

export default {
	components: {
		CoreFormInput,
		JButton
	},
	props: {
		amount: {
			type: Number
		},
		type: {
			type: String
		},
		isLoading: {
			type: Boolean
		}
	},
	data() {
		return {
			premium: this.amount
		}
	},
	methods: {
		async handleSave() {
			const isValid = await this.$validator.validate()
			if (!isValid) return

			this.$emit("created", { type: this.type, amount: this.premium })
		},
		handleCancel() {
			this.$emit("cancelled")
		}
	}
}
</script>

<style>
</style>
